import { contentV1GetMitreEnterpriseOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetMitreEnterprise = () => {
  const { workspace } = useWorkspace();
  return useQuery({
    ...contentV1GetMitreEnterpriseOptions({
      ...defaultOptions(),
      path: { workspace },
    }),
    enabled: !!workspace,
  });
};
